import { I18n } from '@calendly/i18n';
import { IconButton } from '@calendly/ui/components/icon-button';
import { CloseMiniIcon } from '@calendly/ui/components/icons';
import { LabelText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { nanoid } from 'nanoid';
import { useMemo, forwardRef } from 'react';
import { useGetUserQuery } from 'common';
import { DatePopup } from 'components/availability/form/date_specific_rules/date_popup';
import { useToggleState } from 'hooks/useToggleState';
import { Date, IntervalsContainer, ShowMoreButton } from './components';
import { MAX_RULES_TO_SHOW } from './constants';
import { RuleContainer, Wrapper, YearContainer } from './styles';
import { getRules, groupByYear } from '../../utils';
const removeButtonContainerCss = "r107r4ys";
const RemoveButtonContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(removeButtonContainerCss, props.className)} />;
});
export const DateSpecificFields = ({
  days,
  dates,
  setDates,
  editingDates,
  setEditingDates,
  timezone
}) => {
  const {
    data: {
      time_notation: timeNotation
    }
  } = useGetUserQuery();
  const [showMore, toggleShowMore] = useToggleState(false);
  const rulesGroupedByInterval = useMemo(() => getRules(dates), [dates]);
  const formattedActiveDates = useMemo(() => {
    const rulesToShow = showMore ? rulesGroupedByInterval : rulesGroupedByInterval.slice(0, MAX_RULES_TO_SHOW);
    return groupByYear(rulesToShow).map(([year, items]) => [year, items.map(attrs => ({
      ...attrs,
      uid: nanoid(5)
    }))]);
  }, [rulesGroupedByInterval, showMore]);
  const showShowMore = rulesGroupedByInterval.length > MAX_RULES_TO_SHOW;
  const removeDates = dateRange => {
    setDates(dates.filter(({
      date
    }) => !dateRange.includes(date)));
  };
  return <Wrapper data-component="rules-container">
      {formattedActiveDates.map(([year, items]) => <YearContainer key={year} data-component={`${year}-rules`}>
          <LabelText size="medium">
            {year}
          </LabelText>
          {items.map(({
        dates: dateRange,
        intervals,
        uid
      }) => <RuleContainer key={uid} tabIndex={0} onClick={() => setEditingDates(dateRange)} onKeyDown={event => {
        if (event.key === 'Enter' || event.key === ' ') {
          setEditingDates(dateRange);
        }
      }} aria-label={I18n.t('publisher.event_type_editor.sections.available_hours.date_overrides.edit_date_specific_hours_label', {
        dateRange
      })}>
              <Date dateRange={dateRange} />
              <IntervalsContainer intervals={intervals} timeNotation={timeNotation} />
              <RemoveButtonContainer>
                <IconButton size="small" onClick={event => {
            event.stopPropagation();
            removeDates(dateRange);
          }} onKeyDown={event => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              event.stopPropagation();
              removeDates(dateRange);
            }
          }} title={I18n.t('publisher.event_type_editor.sections.available_hours.date_overrides.remove_date_specific_hours_label', {
            dateRange
          })}>
                  <CloseMiniIcon />
                </IconButton>
              </RemoveButtonContainer>
            </RuleContainer>)}
        </YearContainer>)}
      {showShowMore && <ShowMoreButton totalRules={rulesGroupedByInterval.length} isExpanded={showMore} onClick={toggleShowMore} />}
      {editingDates && <DatePopup days={days} dates={dates} setDates={setDates} defaultDays={editingDates} onClose={() => setEditingDates(null)} timezone={timezone} />}
    </Wrapper>;
};

require("./date_specific_fields.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./date_specific_fields.js");